<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "RegistracijaSudionikaBase"
}
</script>

<style scoped>

</style>